<template>
	<v-container fluid>
		<div class="bottom-buttons-outer">
			<v-btn color="success" @click="backClick">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn color="success" @click="saveClick">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex sm6 md4 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField v-model="manualPortal.name"
											:error="manualPortalValidation.name"
											:label="'* '+$t('fields.name')"></InputField>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField"
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import ManualPortal from "../models/ManualPortal";

export default {
	name: "ManualPortal",
	components: {CheckBox, InputField, Dropdown},
	data: function () {
		return {
			manualPortal: new ManualPortal({id: this.$route.params.id}),
			manualPortalValidation: {
				id: '',
				name: ''
			},
			initialLoad: false,
			changesHappened: false
		}
	},
	watch: {
		manualPortal: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
	},
	methods: {
		backClick() {
			this.$router.go(-1);
		},
		saveClick() {
			let success = true;

			if (this.manualPortal.name == '') {
				success = false;
				this.manualPortalValidation.name = this.$t('alerts.fieldError');
			} else {
				this.manualPortalValidation.name = '';
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.manualPortal.id != 0) {
					action = 'put';
					addition = '/' + vm.manualPortal.id;
				}
				this.$APICall(action, 'manual-portals' + addition, this.manualPortal, (data, success) => {
					if (success) {
						vm.changesHappened = false;
						if (vm.manualPortal.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$triggerReload();
						vm.backClick();
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		let vm = this;
		if (this.manualPortal.id != 0) {
			this.$APICall('get', 'manual-portals/' + this.manualPortal.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.$myStore.commit('setBreadcrumbs', [
						{text: vm.$t('modules.manualPortals'), href: '/#/manual-portals', disabled: false},
						{text: vm.manualPortal.email, href: '/#/manual-portals/' + vm.manualPortal.id, disabled: true}
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
					usableData.password_change = false;
					vm.manualPortal = usableData;
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.manualPortals'), href: '/#/manual-portals', disabled: false},
				{text: this.$t('modules.newManualPortal'), href: '/#/manual-portals/0', disabled: true}
			]);
			this.initialLoad = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				next(result);
			});
		} else {
			next(true);
		}
	}
}
</script>

<style scoped>

</style>
